"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_flow_renderer_1 = require("react-flow-renderer");
require("./circleDotNode.scss");
const CircleDotNode = () => {
    return (react_1.default.createElement("div", { className: "circle-dot-node" },
        react_1.default.createElement(react_flow_renderer_1.Handle, { type: "target", position: react_flow_renderer_1.Position.Left }),
        react_1.default.createElement(react_flow_renderer_1.Handle, { type: "target", position: react_flow_renderer_1.Position.Bottom, id: "bottom-handle" }),
        react_1.default.createElement(react_flow_renderer_1.Handle, { type: "source", position: react_flow_renderer_1.Position.Right })));
};
exports.default = CircleDotNode;
